import { DocumentsApi } from 'apis/DocumentsApi'
import { WorkawareApi } from 'apis/WorkawareApi'
import { GraphDataRequestDto } from 'components/liveReporting/types'
import { LiveReportComponentDto } from 'data/dtos/LiveReportComponentDto'
import { ValueTranslationRequestDto } from 'data/dtos/ValueTranslationDto'
import { DashboardDataDTO } from 'data/dtos/DashboardDataDTO'
import { AssignmentReportFilter, AssignmentReportStatsDto } from 'data/dtos/AssignmentReportDto'
import { ScheduledItemReportFilter, ScheduledItemReportStatsDto } from 'data/dtos/ScheduledItemReportDto'
import { JourneyReportFilter, JourneyReportStatsDto } from 'data/dtos/JourneyReportDto'
import { TrainingReportFilter, TrainingReportStatsDto } from 'data/dtos/TrainingReportDto'
import { PolicyReportFilter, PolicyReportStatsDto } from 'data/dtos/PolicyReportDto'
import { AssetMaintenanceReportFilter, AssetMaintenanceReportStatsDto } from 'data/dtos/AssetMaintenanceReportDto'
import { AssetReliabilityReportFilter, AssetReliabilityReportStatsDto } from 'data/dtos/AssetReliabilityReportDto'
import { SiteLocationReportFilter, SiteLocationReportStatsDto } from 'data/dtos/SiteLocationReportDto'
import { ExceptionsRisksReportFilter, ExceptionsRisksReportStatsDto } from 'data/dtos/ExceptionsRisksReportDto'
import { ActivityLogReportFilter, ActivityLogReportStatsDto } from 'data/dtos/ActivityLogReportDto'
import { WorkforcePerformanceReportFilter, WorkforcePerformanceReportStatsDto } from 'data/dtos/WorkforcePerformanceReportDto'
import { ExecutiveOverviewReportFilter, ExecutiveOverviewStatsDto } from 'data/dtos/ExecutiveOverviewReportDto'
import { FormsInspectionsReportFilter, FormsInspectionsReportStatsDto } from 'data/dtos/FormsInspectionsReportDto'

export class reportingService {
  private _api: DocumentsApi
  private _workawareApi: WorkawareApi

  constructor(api: DocumentsApi, workawareApi: WorkawareApi) {
    this._api = api
    this._workawareApi = workawareApi
  }

  translateIds = async (data: ValueTranslationRequestDto) => {
    return await this._workawareApi.reporting.utilities.translate(data)
  }
getDashbaordData = () => {
    return new Promise<DashboardDataDTO>((resolve, reject) => {
      this._workawareApi.reporting.utilities.getDashbaordData()
        .then((result) => resolve(result as DashboardDataDTO))
        .catch((error) => reject(error))
    })
}
getUserDashboardData = (): Promise<any> => {
    return this._workawareApi.reporting.utilities.getUserDashboardData()
}

getAssignmentReportStats = (params: AssignmentReportFilter): Promise<AssignmentReportStatsDto> => {
    return this._workawareApi.reporting.assignments.getStats(params)
}

getScheduledItemReportStats = (params: ScheduledItemReportFilter): Promise<ScheduledItemReportStatsDto> => {
    return this._workawareApi.reporting.scheduledItems.getStats(params)
}

getJourneyReportStats = (params: JourneyReportFilter): Promise<JourneyReportStatsDto> => {
    return this._workawareApi.reporting.journeys.getStats(params)
}

getTrainingReportStats = (params: TrainingReportFilter): Promise<TrainingReportStatsDto> => {
    return this._workawareApi.reporting.training.getStats(params)
}

getCertRecords = (): Promise<any[]> => {
    return this._workawareApi.reporting.training.getCertRecords()
}

getPolicyReportStats = (params: PolicyReportFilter): Promise<PolicyReportStatsDto> => {
    return this._workawareApi.reporting.policies.getStats(params)
}

getAssetMaintenanceReportStats = (params: AssetMaintenanceReportFilter): Promise<AssetMaintenanceReportStatsDto> => {
    return this._workawareApi.reporting.assetMaintenance.getStats(params)
}

getAssetReliabilityReportStats = (params: AssetReliabilityReportFilter): Promise<AssetReliabilityReportStatsDto> => {
    return this._workawareApi.reporting.assetReliability.getStats(params)
}

getSiteLocationReportStats = (params: SiteLocationReportFilter): Promise<SiteLocationReportStatsDto> => {
    return this._workawareApi.reporting.siteLocation.getStats(params)
}

getExceptionsRisksReportStats = (params: ExceptionsRisksReportFilter): Promise<ExceptionsRisksReportStatsDto> => {
    return this._workawareApi.reporting.exceptions.getStats(params)
}

getActivityLogReportStats = (params: ActivityLogReportFilter): Promise<ActivityLogReportStatsDto> => {
    return this._workawareApi.reporting.activityLog.getStats(params)
}

getWorkforcePerformanceReportStats = (params: WorkforcePerformanceReportFilter): Promise<WorkforcePerformanceReportStatsDto> => {
    return this._workawareApi.reporting.workforce.getStats(params)
}

getExecutiveOverviewStats = (params: ExecutiveOverviewReportFilter): Promise<ExecutiveOverviewStatsDto> => {
    return this._workawareApi.reporting.executive.getStats(params)
}

getFormsInspectionsStats = (params: FormsInspectionsReportFilter): Promise<FormsInspectionsReportStatsDto> => {
    return this._workawareApi.reporting.forms.getStats(params)
}

getTotalFormTemplates = (): Promise<Array<{Id: number, Name: string, Color?: string, DateUploaded?: string}>> => {
    return this._workawareApi.forms.templates.allWithDates()
        .then((result: any) => result.value ?? [])
}
  aggregate = async (query: string) => {
    return await this._api.documents.aggregate(query)
  }

  getBarGraphData =  async (dto: GraphDataRequestDto) => {
    return this._api.liveData.getBarGraphData(dto)
  }

  getPieGraphData =  async (dto: GraphDataRequestDto) => {
    return this._api.liveData.getPieGraphData(dto)
  }

  getLiveReports = async () => {
    const result = await this._api.live.list()
    return result.map((r) => ({
      value: r._id,
      name: r.title,
    }))
  }

  getLiveReport = async (id: string) => {
    const result = await this._api.live.report(id)
    return result
  }

  createLiveReport = async (name: string) => {
    const result = await this._api.live.create({ name })
    return {
      value: result._id,
      name: result.title,
    }
  }

  addComponent = async (reportId: string, dto: LiveReportComponentDto) => {
    return await this._api.live.addComponent(reportId, dto)
  }

  removeComponent = async (reportId: string, componentId: string) => {
    return await this._api.live.removeComponent(reportId, componentId)
  }

  saveComponentOptions = async (reportId: string, componentId: string, options: string) => {
    return await this._api.live.saveComponentOptions(reportId, componentId, options)
  }

  saveComponentLabel = async (reportId: string, componentId: string, label: string) => {
    return await this._api.live.saveComponentLabel(reportId, componentId, label)
  }

  saveLayout = async (reportId: string, layout: string) => {
    return await this._api.live.saveLayout(reportId, layout)
  }
}
